if (document.querySelector('.stackla-block')) {
  const script = document.createElement('script');
  script.src = '//assetscdn.stackla.com/media/js/widget/fluid-embed.js';
  script.id = 'stackla-widget-js';
  document.body.appendChild(script);
}